<template>
    <div class="items-item">
        <div class="background-icon" :class="parent.slug">
            <i :class="parent.slug === $t('analysesSlug') ? 'fa fa-bar-chart-o' :
                            (parent.slug === $t('formsSlug') ? 'fa fa-file-pdf-o' :
                                (parent.slug === $t('registersSlug') ? 'fa fa-bars vertical-bars' : 
                                    (parent.slug === $t('financialProfessionalSlug') ? 'fa fa-calculator' : 'fa fa-book')))">
            </i>
        </div>
        <div class="background-icon-down" :class="parent.slug">
            <i :class="parent.slug === $t('analysesSlug') ? 'fa fa-bar-chart-o' :
                            (parent.slug === $t('formsSlug') ? 'fa fa-file-pdf-o' :
                                (parent.slug === $t('registersSlug') ? 'fa fa-bars vertical-bars' : 
                                    (parent.slug === $t('financialProfessionalSlug') ? 'fa fa-calculator' : 'fa fa-book')))">
            </i>
        </div>
        <div class="card-content">
            <div class="card-header">
                <div>
                    <router-link v-if="!isExternalLink" v-bind:to="computeRoute" tag="a">
                        <h3>{{ menu.title }}</h3>
                    </router-link>
                    <a v-else v-bind:href="menu.url" target="_blank">
                        <h3>{{ menu.title }}</h3>
                    </a>
                </div>
            </div>

            <div class="card-body">
                <p v-if="htmlContent" v-html="truncatedHtmlContent"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    props: ["id", "hierarchyLevel", "isDetails", "isContent"],
    name: "AppSubMenuItem",
    data() {
        return {
            menu: null,
            htmlContent: "",
            defaultIndent: 5,
            parent: null
        }
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.fetchContentById(this.id).then((contentResposnse) => {
                this.menu.title = contentResposnse.title;
                this.menu.url = contentResposnse.url;
                this.menu.slug = contentResposnse.slug;
                this.htmlContent = contentResposnse.content;
            });
        }
    },
    computed: {
        ...mapGetters(["getContentById", "getContentMedia", "getSelectedLanguage", "getContentTypes"]),
        isZeroHierarchy() {
            return this.hierarchyLevel == 0;
        },
        isExternalLink() {
            return (this.menu.url != null && ((this.menu.contentTypeId == this.getContentTypes.linkContentTypeId && this.menu.url.startsWith("http")) ||
                (this.menu.contentTypeId == this.getContentTypes.highlightedServicesTypeId && this.menu.url.startsWith("http")) ||
                (this.menu.contentTypeId == this.getContentTypes.subMenuTypeId && this.menu.url.startsWith("http"))));
        },
        isInternalLink() {
            return (this.menu.url != null && ((this.menu.contentTypeId === this.getContentTypes.linkContentTypeId && !this.menu.url.startsWith("http")) ||
                (this.menu.contentTypeId === this.getContentTypes.highlightedServicesTypeId && !this.menu.url.startsWith("http")) ||
                (this.menu.contentTypeId === this.getContentTypes.subMenuTypeId && !this.menu.url.startsWith("http"))));
        },
        computeRoute() {

            if (this.parent.contentTypeId === this.$store.state.contentTypes.highlightedServicesTypeId) {
                return this.isInternalLink
                    ? { name: this.menu.url }
                    : { name: 'menuDetailsNew', params: { id: this.menu.id, slug: this.menu.slug } };
            }

            if (this.menu.contentTypeId === this.$store.state.contentTypes.newsContentType) {
                return { name: 'news-content', params: { id: this.menu.id, slug: null } };
            }
            if (this.menu.slug === this.$t('noteSlug')) {
                const urlParts = this.menu.url.split('/');
                return { name: 'news-content', params: { id: urlParts[1], slug: urlParts[2] } };
            }

            if (this.isInternalLink) {
                const routeExists = this.$router.options.routes.some(route => {
                    return route.name === this.menu.url || (route.children && route.children.some(child => child.name === this.menu.url));
                });

                if (routeExists) {
                    return { name: this.menu.url };
                } else {
                    const urlParts = this.menu.url.split('/');
                    return { name: 'menuDetailsNew', params: { id: urlParts[1], slug: urlParts[2] } };
                }
            }

            return { name: 'contentNew', params: { id: this.menu.id, slug: this.menu.slug } };
        },
        truncatedHtmlContent() {
            const plainText = (this.htmlContent || '').replace(/<[^>]*>/g, '');
            return plainText.length > 150 ? plainText.substring(0, 150) + '...' : plainText;
        },
        // isRRFL() {
        //     return this.menu.slug && this.menu.slug === this.$t("RRFLRouteName");
        // }
    },
    created() {
        this.menu = this.getContentById(this.id);
        this.parent = this.getContentById(this.menu.parentId);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
        content() {
            this.loadData();
        }
    },
}
</script>

<style scoped>
.items-item {
    position: relative;
    overflow: hidden;
    padding: 25px;
    background: linear-gradient(135deg, #F4F7FD 0%, #E0E6F5 100%);
    border-radius: 8px;
    box-shadow: 0 6px 15px rgba(36, 59, 128, 0.08);
    transition: transform 0.3s ease;
    border: 1px solid #E0E6F5;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: 100%;
}

.items-item:hover {
    transform: scale(1.01);
    box-shadow: 0 12px 20px rgba(36, 59, 128, 0.12);
}

.background-icon, .background-icon-down {
    position: absolute;
    right: -10px;
    top: 40px;
    font-size: 100px;
    opacity: 0.05;
    color: var(--main-color);
    transform: rotate(10deg);
    transition: all 0.5s ease;
}

.background-icon-down {
    display: none; /* Simplifying to match the first design */
}

.items-item:hover .background-icon {
    transform: rotate(15deg) scale(1.3);
    opacity: 0.1;
}

.card-content {
    position: relative;
    z-index: 2;
}

.card-header
{
    background-color: #E0E6F5;
}

.card-header a {
    text-decoration: none;
    display: block;
}

.card-header h3 {
    font-size: 24px;
    color: var(--main-color);
    font-weight: 600;
    transition: color 0.3s ease;
    margin: 0;
}

.card-header a:hover h2 {
    text-decoration: underline;
    text-decoration-color: var(--main-color);
    font-weight: 600;
}

.card-body {
    padding: 0;
    margin-top: 8px;
}

.card-body p {
    color: var(--main-color);
    opacity: 0.8;
    line-height: 1.2;
    margin: 0;
    font-size: 18px;
}

.vertical-bars {
    transform: rotate(90deg);
}

@media only screen and (max-width: 768px) {
    .items-item {
        flex: 1 1 100%;
    }
}
</style>
